import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const DeadboltHole = ({ value, onChange, label = 'Deadbolt Hole', passSelectedDoor }) => {
    const [selectedDeadboltHole, setSelectedDeadboltHole] = useState(value || "");

    useEffect(() => {
            if (passSelectedDoor) { }
    }, [passSelectedDoor]); // Trigger effect whenever passSelectedDoor changes

    const handleDeadboltHoleChange = (e) => {
        const newValue = e.target.value;
        setSelectedDeadboltHole(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="DeadboltHole">{label}</label>
            <select style={{ display: "none" }}
                id="DeadboltHole"
                value={selectedDeadboltHole}
                onChange={handleDeadboltHoleChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="None">         {selectedDeadboltHole === "None" ? "None ✔" : "None"}</option>
              <option value="YesActiveDoor">{selectedDeadboltHole === "YesActiveDoor" ? "Yes - Active Door ✔" : "Yes - Active Door"}</option>
              {passSelectedDoor && [5, 6, 7, 8].includes(passSelectedDoor.id) && (
              <option value="YesBothDoors"> {selectedDeadboltHole === "YesBothDoors" ? "Yes - Both Doors ✔" : "Yes - Both Doors"}</option>
              )}
            </select>
        </div>
    );
};

export default DeadboltHole;
